import(/* webpackMode: "eager" */ "/vercel/path0/src/app/industries/construction/page.tsx");
